import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cynergy-homepage-v2/artifacts/r1v9vkwo_cynergysports_logo_full.png";

const FOOTER_NAV = {
  Sports: [
    { label: "Latest News", href: "/sport-news" },
    { label: "Swimming", href: "/sports" },
    { label: "Para Swimming", href: "/sports/para-swimming" },
    { label: "Interviews", href: "/interviews" },
  ],
  Travel: [
    { label: "Destinations", href: "/travel" },
    { label: "Swim Holidays", href: "/travel" },
    { label: "Wellness & Yoga", href: "/travel" },
    { label: "Swim Camps", href: "/travel" },
  ],
  Community: [
    { label: "Clubs Directory", href: "/clubs" },
    { label: "Competition Meets", href: "/meets" },
    { label: "About Us", href: "https://www.cynergyservices.org/about" },
    { label: "Contact", href: "https://www.cynergyservices.org/contact" },
  ],
};

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-near-black border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-4">
            <img
              src={LOGO_URL}
              alt="CynergySports"
              className="h-10 w-auto object-contain mb-6"
            />
            <p className="font-inter font-normal text-sm text-white/50 leading-relaxed max-w-xs mb-6">
              Digital-first sports media portal bringing fans, athletes, and communities together. Sports belong to everyone.
            </p>
            <p className="font-inter font-light text-xs tracking-[0.15em] uppercase text-solar-orange">
              Sports for all
            </p>
          </div>

          {/* Navigation Columns */}
          {Object.entries(FOOTER_NAV).map(([title, links]) => (
            <div key={title} className="md:col-span-2">
              <h4 className="font-inter font-semibold text-sm text-white tracking-wide mb-5">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                      className="font-inter font-normal text-sm text-white/40 hover:text-solar-orange transition-colors duration-150 inline-flex items-center gap-1 group"
                    >
                      {link.label}
                      <ArrowUpRight size={11} className="opacity-0 group-hover:opacity-100 transition-opacity duration-150" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Stay Updated */}
          <div className="md:col-span-2">
            <h4 className="font-inter font-semibold text-sm text-white tracking-wide mb-5">
              Stay Updated
            </h4>
            <p className="font-inter font-normal text-sm text-white/40 leading-relaxed mb-4">
              Follow our latest stories and swim-travel guides.
            </p>
            <Link
              to="/sport-news"
              data-testid="footer-subscribe-link"
              className="inline-flex items-center gap-2 bg-solar-orange/10 text-solar-orange font-inter font-medium text-xs px-4 py-2.5 rounded-sm hover:bg-solar-orange/20 transition-colors duration-150"
            >
              Read Latest
              <ArrowUpRight size={12} />
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-inter font-light text-xs text-white/30">
            &copy; {new Date().getFullYear()} CynergySports. All rights reserved.
          </p>
          <div className="flex gap-6">
            {/* <Link to="/" className="font-inter font-light text-xs text-white/30 hover:text-white/50 transition-colors duration-150">
              Privacy Policy
            </Link>
            <Link to="/" className="font-inter font-light text-xs text-white/30 hover:text-white/50 transition-colors duration-150">
              Terms of Service
            </Link> */}
          </div>
        </div>
      </div>

      {/* Large Brand Text */}
      <div className="overflow-hidden border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-8">
          <p
            data-testid="footer-brand-text"
            className="font-inter font-semibold text-5xl md:text-7xl lg:text-8xl tracking-tighter text-white/[0.03] select-none whitespace-nowrap"
          >
            CYNERGYSPORTS
          </p>
        </div>
      </div>
    </footer>
  );
}
